import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Navbar } from '../navbar/navbar';

@Component({
  selector: 'nexa-authenticated-layout',
  imports: [RouterOutlet, Navbar],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nexa-navbar />
    <router-outlet />
  `,
  styles: `
    :host {
      --nexa-navbar-height: 4rem;
    }
  `,
})
export class AuthenticatedLayout {}
